export default {
  title: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_title',
    defaultMessage: 'What is the counteroffer price?',
  },
  paragraph: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_paragraph',
    defaultMessage: 'Set a new price according to your assessment.',
  },
  assessmentTitle: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_assessment_title',
    defaultMessage: 'Your assessment',
  },
  fileInputLabel: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_file_input_label',
    defaultMessage: 'Add photo',
  },
  fileInputDescription: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_file_input_description',
    defaultMessage: 'jpeg, png',
  },
  fileTooLargeError: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_max_file_size_error',
    defaultMessage: 'The file is too large.',
  },
  tooManyFilesError: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_max_files_number_error',
    defaultMessage: 'Max 5 files allowed',
  },
  textInputComment: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_input_comment_label',
    defaultMessage: 'Your comment',
  },
  textInputCounterOfferPrice: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_input_counter_offer_price_label',
    defaultMessage: 'New price',
  },
  textInputCounterOfferPriceError: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_input_counter_offer_price_error',
    defaultMessage: 'Only integers',
  },
  textInputPrice: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_input_price_label',
    defaultMessage: 'Initial price',
  },
  infoTitle: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_info_block_title',
    defaultMessage: 'Counteroffer tips',
  },
  infoContent: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_info_block_content',
    defaultMessage:
      'The Back Market customer is more likely to accept your counteroffer when you provide a detailed explanation as to why their original assessment didn’t match up to your own.',
  },
  charactersLeft: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_text_area_char_count',
    defaultMessage: '{count} characters left',
  },
  appearanceTitle: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_appearance',
    defaultMessage: 'Appearance',
  },
  functionalTitle: {
    id: 'buyback_refurbisher_on_hold_modal_counter_offer_details_functional',
    defaultMessage: 'Functional',
  },
  required: {
    id: 'buyback_shared_required_field',
    defaultMessage: 'This field is required',
  },
}
